export interface ProgressReviewMetaInterface {
  buyerId: string;
  sellerId: string;
  gigId: string;
  channelId: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface ProgressReviewInterface {
  id: string;
  order: string;
  remarks?: string;
  screenshotUrlList: string[];
  metaData: ProgressReviewMetaInterface;
  createdAt?: Date;
  updatedAt?: Date;
}

export class ProgressReviewMeta implements ProgressReviewMetaInterface {
  buyerId: string;
  sellerId: string;
  gigId: string;
  channelId: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(jsonData: any) {
    this.buyerId = jsonData.buyerId;
    this.sellerId = jsonData.sellerId;
    this.gigId = jsonData.gigId;
    this.channelId = jsonData.channelId;
    this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
    this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
  }
}

export class ProgressReview implements ProgressReviewInterface {
  id: string;
  order: string;
  remarks?: string;
  screenshotUrlList: string[];
  metaData: ProgressReviewMetaInterface;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(jsonData: any) {
    this.id = jsonData._id;
    this.order = jsonData.order;
    this.remarks = jsonData.remarks;
    this.screenshotUrlList = Array.isArray(jsonData?.screenshotUrlList)
      ? jsonData.screenshotUrlList.filter((url: unknown): url is string => typeof url === 'string')
      : [];
    this.metaData = new ProgressReviewMeta(jsonData.metaData);
    this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
    this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
  }
}
